import Layout from '@/layouts/PublicLayout';
import Home from '@/views/public/Home';
import Business from '@/views/public/business/Businesses';
import BusinessView from '@/views/public/business/BusinessView';
import BusinessInfo from '@/views/user/BusinessInfo';
import BusinessCoop from '@/views/user/BusinessCoop';
import BusinessFeedback from '@/views/user/BusinessFeedback';
import BusinessProduct from '@/views/user/BusinessProduct';
import News from '@/views/public/news/News';
import NewsView from '@/views/public/news/NewsView';
import Environment from '@/views/public/Environment';
import AgriMap from '@/views/public/AgriMap';
import SpecialProduct from '@/views/public/products/SpecialProducts';
import OcopProduct from '@/views/public/products/OcopProduct';
import ChainProduct from '@/views/public/products/ChainProduct';
import TreeProductTrace from '@/views/public/products/TreeProductTrace';
import AnimalProductTrace from '@/views/public/products/AnimalProductTrace';
import ChainProductTrace from '@/views/public/products/ChainProductTrace';
import OcopProductTrace from '@/views/public/products/OcopProductTrace';
import ProductGroup from '@/views/public/products/ProductGroup';
import MarketPrice from '@/views/public/markets/Market';
import MarketView from '@/views/public/markets/MarketView';
import UserIndex from '@/views/user/Index';
import UserProfile from '@/views/user/Profile';
import UserBusiness from '@/views/user/Business';
import UserSupport from '@/views/user/UserSupport';
import Support from '@/views/public/supports/Support';
import SupportView from '@/views/public/supports/SupportView';
import Expert from '@/views/public/supports/Expert';
import ExpertView from '@/views/public/supports/ExpertView';
import Trade from '@/views/public/trades/Trade';
import TradeView from '@/views/public/trades/TradeView';
import FrontPageContact from '@/views/public/Contact';
import ProductTrace from '@/views/public/products/ProductTrace';
import ProductTraceView from '@/views/public/products/ProductTraceView';
import HomeReport from '@/views/public/report/Index';
import About from '@/views/public/About';

const routes = [
  {
    path: '',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
          title: 'Trang chủ'
        }
      },
      {
        path: 'business',
        name: 'Business',
        component: Business,
        meta: {
          title: 'Cơ sở kinh doanh'
        }
      },
      {
        path: 'business/:view',
        name: 'BusinessTypeView',
        component: Business
      },
      {
        path: 'business/:id/view',
        name: 'BusinessView',
        component: BusinessView
      },
      {
        path: 'products',
        name: 'ProductGroup',
        component: ProductGroup,
        meta: {
          title: 'Nhóm sản phẩm'
        }
      },
      {
        path: 'products/special/:type',
        name: 'SpecialProduct',
        component: SpecialProduct,
        meta: {
          title: 'Sản phẩm đặc sản'
        }
      },
      {
        path: 'products/ocop',
        name: 'OcopProduct',
        component: OcopProduct,
        meta: {
          title: 'Sản phẩm Ocop'
        }
      },
      {
        path: 'products/chain',
        name: 'ChainProduct',
        component: ChainProduct,
        meta: {
          title: 'Sản phẩm chuỗi'
        }
      },
      {
        path: 'products/tracing',
        name: 'ProductTrace',
        component: ProductTrace,
      },
      {
        path: 'products/tracing/:id/detail',
        name: 'ProductTraceView',
        component: ProductTraceView,
      },
      {
        path: 'products/special/tree/:id/detail',
        name: 'TreeProductTrace',
        component: TreeProductTrace
      },
      {
        path: 'products/special/animal/:id/detail',
        name: 'AnimalProductTrace',
        component: AnimalProductTrace
      },
      {
        path: 'products/ocop/:id/detail',
        name: 'OcopProductTrace',
        component: OcopProductTrace,
        meta: {
          title: 'Truy xuất Sản phẩm Ocop'
        }
      },
      {
        path: 'products/chain/:id/detail',
        name: 'ChainProductTrace',
        component: ChainProductTrace,
        meta: {
          title: 'Truy xuất Sản phẩm chuỗi'
        }
      },
      {
        path: 'news',
        name: 'News',
        component: News,
        meta: {
          title: 'Tin tức'
        }
      },
      {
        path: 'news/:id/view',
        name: 'NewsView',
        component: NewsView
      },
      {
        path: 'environment',
        name: 'Environment',
        component: Environment,
        meta: {
          title: 'Quan trắc môi trường'
        }
      },
      {
        path: 'agri-map',
        name: 'AgriMap',
        component: AgriMap,
        meta: {
          title: 'Bản đồ nông nghiệp'
        }
      },
      {
        path: 'market-price',
        name: 'MarketPrice',
        component: MarketPrice,
        meta: {
          title: 'Giá cả thị trường'
        }
      },
      {
        path: 'market-price/:date/view',
        name: 'MarketView',
        component: MarketView,
        meta: {
          title: 'Giá cả thị trường'
        }
      },
      {
        path: 'user-index',
        name: 'UserIndex',
        component: UserIndex,
        meta: {
          title: 'UserIndex'
        }
      },
      {
        path: "user",
        component: UserIndex,
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: 'profile',
            component: UserProfile,
            name: 'UserProfile'
          },
          {
            path: 'supports',
            component: UserSupport,
            name: 'UserSupport'
          },
          {
            path: 'support/:user/show/:show',
            component: UserSupport,
            name: 'UserSupportShow'
          },
          {
            path: 'business',
            component: UserBusiness,
            name: 'UserBusiness',
            children: [
              {
                path: 'info',
                component: BusinessInfo,
                name: 'BusinessInfo'
              },
              {
                path: 'products',
                component: BusinessProduct,
                name: 'BusinessProduct'
              },
              {
                path: 'coops',
                component: BusinessCoop,
                name: 'BusinessCoop'
              },
              {
                path: 'feedbacks',
                component: BusinessFeedback,
                name: 'BusinessFeedback'
              }
            ]
          },
        ]
      },
      {
        path: "supports",
        component: {
          render: (c) => c('router-view'),
        },
        children: [
          {
            path: '/',
            component: Support,
            name: 'Support'
          },
          {
            path: ':id/view',
            name: 'SupportView',
            component: SupportView
          },
          {
            path: 'experts',
            component: Expert,
            name: 'Expert'
          },
          {
            path: 'expert/:id/view',
            component: ExpertView,
            name: 'ExpertView'
          }
        ]
      },
      {
        path: "trades",
        component: {
          render: (c) => c('router-view'),
        },
        children: [
          {
            path: '/',
            component: Trade,
            name: 'Trade'
          },
          {
            path: ':id/view',
            component: TradeView,
            name: 'TradeView'
          }
        ]
      },
      {
        path: 'contact',
        name: 'FrontPageContact',
        component: FrontPageContact,
        meta: {
          title: 'Liên hệ, phản hồi'
        }
      },
      {
        path: 'report',
        name: 'HomeReport',
        component: HomeReport
      }
    ]
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
];

export default routes;